module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/HeartGirl-10b6ee747d21b2d8c8cbea93337ec8c7.png";